import { FunctionComponent, useState } from "react";
import { Pivot, PivotItem } from "@bps/fluent-ui";
import { TenantUsersAuthForm } from "./TenantUsersAuthForm";
import { TenantUsersNetworkingSection } from "./TenantUsersNetworkingSection";

interface TenantUsersAuthTabsWrapperProps {
  tenantId: string;
}

enum TenantUsersAuthTabs {
  Authentication = "Authentication",
  Network = "Network"
}

export const TenantUsersAuthTabsWrapper: FunctionComponent<TenantUsersAuthTabsWrapperProps> = ({
  tenantId
}) => {
  const [selectedKey, setSelectedKey] = useState<TenantUsersAuthTabs>(
    TenantUsersAuthTabs.Authentication
  );
  return (
    <Pivot
      selectedKey={selectedKey}
      styles={{ itemContainer: { padding: 8 } }}
      onLinkClick={item => {
        setSelectedKey(item?.props.itemKey as TenantUsersAuthTabs);
      }}
    >
      <PivotItem
        itemKey={TenantUsersAuthTabs.Authentication}
        headerText="Authentication"
      >
        <TenantUsersAuthForm tenantId={tenantId} />
      </PivotItem>

      <PivotItem itemKey={TenantUsersAuthTabs.Network} headerText="Networking">
        <TenantUsersNetworkingSection tenantId={tenantId} />
      </PivotItem>
    </Pivot>
  );
};
